export default __webpack_public_path__ + "static/media/CL04.1.5602978a.mp3";